/* Fresca — product page: sticky add-to-cart bar, price sync, gallery depth */
(() => {
  'use strict';
  const pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(pointer: fine)').matches;

  /* Sticky bar: visible while the main buy row is scrolled past, and hidden again whenever
     a section with its own buy button is on screen (the combo deal) or the footer is reached. */
  const bar = document.querySelector('[data-pdp-bar]');
  const buy = pdp.querySelector('[data-pdp-buy]');
  if (bar && buy && 'IntersectionObserver' in window) {
    let buyOut = false;
    const blockers = new Set();
    const sync = () => {
      const on = buyOut && blockers.size === 0;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('has-pdp-bar', on);
    };
    new IntersectionObserver(([en]) => {
      // only "out" once the buy row has scrolled above the viewport, not while it is still below it
      buyOut = !en.isIntersecting && en.boundingClientRect.top < 0;
      sync();
    }, { rootMargin: '0px 0px -90px 0px' }).observe(buy);
    const block = new IntersectionObserver((entries) => {
      entries.forEach((en) => (en.isIntersecting ? blockers.add(en.target) : blockers.delete(en.target)));
      sync();
    }, { rootMargin: '0px 0px -12% 0px' });
    document.querySelectorAll('.fr-combo, [data-combo-deal], .fr-footer').forEach((el) => block.observe(el));
  }

  /* Gallery thumbs: mirror the active state for assistive tech (fresca.js swaps the image) */
  const thumbs = pdp.querySelectorAll('[data-pdp-thumb]');
  thumbs.forEach((t) => t.addEventListener('click', () => {
    thumbs.forEach((o) => o.setAttribute('aria-pressed', String(o === t)));
  }));

  /* Keep the bar price in sync with the variant picker */
  const select = pdp.querySelector('[data-variant-select]');
  const barPrice = bar && bar.querySelector('[data-pdp-bar-price]');
  if (select && barPrice) {
    select.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      if (opt && opt.dataset.price) barPrice.textContent = opt.dataset.price;
    });
  }

  /* Gallery: soft pointer depth on the art layers (desktop only) */
  const stage = pdp.querySelector('[data-pdp-main]');
  if (stage && fine && !reduced) {
    const layers = Array.from(stage.querySelectorAll('[data-pdp-depth]')).map((el) => ({ el, d: parseFloat(el.dataset.pdpDepth) || 0 }));
    if (!layers.length) return;
    let tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
    const loop = () => {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      layers.forEach((l) => { l.el.style.translate = `${(cx * l.d * 10).toFixed(2)}px ${(cy * l.d * 10).toFixed(2)}px`; });
      raf = Math.abs(tx - cx) + Math.abs(ty - cy) > 0.002 ? requestAnimationFrame(loop) : 0;
    };
    const kick = () => { if (!raf) raf = requestAnimationFrame(loop); };
    stage.addEventListener('pointermove', (e) => {
      const r = stage.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
      kick();
    });
    stage.addEventListener('pointerleave', () => { tx = 0; ty = 0; kick(); });
  }
})();
